// @flow
import domainsService from '@clubmed/domains-service';
import { get } from 'lodash';
import accounting from 'accounting';

export type CurrencyOptions = {
  symbol?: string,
  decimal?: string,
  thousand?: string,
  precision?: number,
  format?: string,
};

function buildCurrencyConfig(unit: string) {
  return {
    symbol: unit,
    decimal: ',',
    thousand: ' ',
    precision: 2,
    format: '%v %s',
  };
}

function getCurrency(locale: string, currencyCode: string) {
  const currencyConfig = domainsService.getDomain(locale);
  return get(currencyConfig, `currencies.${currencyCode}`)
    ? currencyConfig.currencies[currencyCode]
    : buildCurrencyConfig(currencyCode);
}

function getCurrencyCode(locale: string) {
  const currencyConfig = domainsService.getDomain(locale);
  return Object.keys(currencyConfig.currencies)[0];
}

function formatAmount(
  amount: ?number,
  currencyCode: string,
  locale: string,
  options: CurrencyOptions = {},
) {
  const currencyConfig = getCurrency(locale, currencyCode);
  return accounting.formatMoney(amount, { ...currencyConfig, ...options });
}

function formatAmountForLocale(
  amount: ?number,
  locale: string,
  currency?: string,
  options?: CurrencyOptions,
) {
  return formatAmount(amount, currency || getCurrencyCode(locale), locale, options);
}

export { getCurrency, getCurrencyCode, formatAmount, formatAmountForLocale };
